export default __webpack_public_path__ + "static/media/thumbsup-dark.f3cf8919.svg";